import React, { Component } from 'react';
import ProgressCircle from './progressCircle';
import * as style from './timelineProgress.module.scss';

class TimelineProgress extends Component {
  constructor() {
    super();
    this.state = {
      progress: 0,
    };
  }
  componentDidMount() {
    this.props.registerNodeListener(this.updateScroll.bind(this));
  }
  updateScroll(scrollHeight, windowHeight) {
    if (this.props.contentWrap) {
      this.setState({
        progress:
          scrollHeight / (this.props.contentWrap.offsetHeight - windowHeight),
      });
    }
  }
  getCurrentIndex() {
    if (!this.props.timelineGroup) {
      return 0;
    }
    return this.props.timelineGroup.timelines.reduce((prev, item, i) => {
      return item.id === this.props.currentId ? i : prev;
    }, 0);
  }

  render() {
    const currentIndex = this.getCurrentIndex();
    return (
      <div className={style.progressWrap}>
        {this.props.timelineGroup &&
          this.props.timelineGroup.timelines.map((item, i) => (
            <ProgressCircle
              key={`progress${item.id}`}
              title={item.timeline_nav_label}
              progress={i === currentIndex && this.state.progress}
              position={i - currentIndex}
              link={item.path}
            />
          ))}
      </div>
    );
  }
}

export default TimelineProgress;
